// ./src/components/cards/CardSimpleIndicator/styles.ts
import styled from 'styled-components';

export const Container = styled.div``;
